import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { CompanyClient, CompanyContactInfo } from '../../../services/nswag/nswagclient';

@Component({
    selector: 'app-contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ContactInfoComponent),
            multi: true
        }],
    standalone: false
})
export class ContactInfoComponent implements OnInit, ControlValueAccessor {

  private _onTouched: () => void = () => {};
  public isDisabled = false;

  @Input() _companyId: string | null = null;
  get companyId() {
    return this._companyId;
  }
  set companyId(val: string | null) {
    this._companyId = val;
    this.propagateChange(this._companyId);
  }

  companyContactInfoColumns: any[] = [];
  companyContactInfo: CompanyContactInfo | null = null;

  constructor(private _companyService: CompanyClient) { }

  ngOnInit() {
    this.companyContactInfoColumns = this.buildColumns();
  }

  /****** ControlValueAccessor methods to handle ngModel read and updates ******/
  propagateChange = (_: any) => {};

  async writeValue(obj: any): Promise<void> {
    if (obj) {
      this.companyId = obj;
      this.companyContactInfo = await this.getContactInfo();
    } else {
      this.companyId = null;
      this.companyContactInfo = null;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  buildColumns(): any[] {
    return [
      { field: 'name', header: 'Name', width: '150px' },
      { field: 'email', header: 'Email', width: '250px' },
      { field: 'phone', header: 'Number', width: '100px' },
    ];
  }

  async getContactInfo(): Promise<CompanyContactInfo | null> {
    let companyContactInfo: CompanyContactInfo | null = null;
    if (this.companyId) {
      companyContactInfo = await firstValueFrom(this._companyService.getCompanyContactInfo(this.companyId));
    }
    return companyContactInfo;
  }

}
